import { useMemo } from 'react';
import { useLazyPostCall } from 'common/api/useApiCall';
import { URLS } from 'constants/URL';

type SilencePayload = {
  startsAt: string;
  endsAt: string;
  computeResourceId?: string;
  serviceIds: string;
};

type OSPatchSilenceRequest = {
  tenantId: string;
  domain: string;
  silencePayload: SilencePayload;
};

export const useOSPatchSilence = () => {
  const {
    response: silenceResponse,
    responseStatus: silenceResponseStatus,
    isLoading: silenceIsLoading,
    postData: submitSilence,
  } = useLazyPostCall(URLS.osPatchSilence);

  const createSilenceRequest = (
    tenantId: string,
    domain: string,
    serviceIds: string[],
    computeResourceId?: string,
    durationHours: number = 3
  ): OSPatchSilenceRequest => {
    const now = new Date();
    const startsAt = now.toISOString();
    const endsAt = new Date(now.getTime() + durationHours * 60 * 60 * 1000).toISOString();

    return {
      tenantId,
      domain,
      silencePayload: {
        startsAt,
        endsAt,
        ...(computeResourceId && { computeResourceId }),
        serviceIds: serviceIds.join(',')
      }
    };
  };

  const silenceResult = useMemo(() => {
    return {
      success: silenceResponseStatus === 200,
      response: silenceResponse,
      status: silenceResponseStatus
    };
  }, [silenceResponse, silenceResponseStatus]);

  return {
    submitSilence,
    silenceIsLoading,
    silenceResult,
    silenceResponse,
    silenceResponseStatus,
    createSilenceRequest
  };
};